const COMPANY_REFRESH_REQUESTED_EVENT = "sport24:company-refresh-requested";

export const requestCompanyRefresh = () => {
  window.dispatchEvent(new Event(COMPANY_REFRESH_REQUESTED_EVENT));
};

export const subscribeCompanyRefresh = (handler) => {
  window.addEventListener(COMPANY_REFRESH_REQUESTED_EVENT, handler);
  return () => window.removeEventListener(COMPANY_REFRESH_REQUESTED_EVENT, handler);
};
